import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TyMonthlyGivingProgramComponent } from './components/ty-monthly-giving-program/ty-monthly-giving-program.component';

@NgModule({
  declarations: [TyMonthlyGivingProgramComponent],
  imports: [
    CommonModule
  ],
  exports: [TyMonthlyGivingProgramComponent]
})
export class TyMonthlyGivingProgramModule { }
